import { FetchErrorName } from './types';

export class ParsingError extends Error {
  public name = FetchErrorName.ParsingError;
  public error?: string;
  public endpoint?: string;
  public url?: string;

  public constructor(message: string, error?: string, endpoint?: string, url?: string) {
    super(message);
    Object.setPrototypeOf(this, ParsingError.prototype);
    this.error = error;
    this.endpoint = endpoint;
    this.url = url;
  }
}
